import React from 'react'
import ReactDOM from 'react-dom';

import {takeLatest} from 'redux-saga/effects';
import {put, select} from 'redux-saga/effects'
import * as actions from '../actions/index';
import * as actionTypes from '../actions/actionTypes';

//Components
import Notification from '../../components/Notifications/Notifications';

//Utils
import qs from 'qs';
import axios from '../../services/axios-client';

export function* getEvents(action) {
    try {
        const companyKey = yield select(state => state.auth.companyKey);
        const userToken = yield select(state => state.auth.userToken);
        const shopID = yield select(state => state.companies.shopId);
        const data = {
            'shop_id': shopID,
            'first': action.first,
            'limit': action.limit
        };
        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/booking/product/event/list',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken,
            },
        });
        if(response.data.result.slots.length === 0) {
            yield put(actions.getEventsSucceeded([], action.first, action.refresh));
            return;
        }
        yield put(actions.getEventsSucceeded(response.data.result.slots, action.first, action.refresh))
    } catch (error) {
        yield put(actions.getEventsFail());
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export const watchEvents = [
    takeLatest(actionTypes.GET_EVENTS, getEvents),
];
